import { render, staticRenderFns } from "./pricing-beta-1.vue?vue&type=template&id=18efb678"
import script from "./pricing-beta-1.vue?vue&type=script&lang=js"
export * from "./pricing-beta-1.vue?vue&type=script&lang=js"
import style0 from "./pricing-beta-1.vue?vue&type=style&index=0&id=18efb678&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports